import { z } from 'zod'
import { oc } from '@orpc/contract'
import { incomingFaxSchema, incomingFaxWithSchema } from './list-incoming-faxes.contract'

export const getIncomingFax = oc
  .route({ method: 'GET', path: '/v2/incoming-faxes/{id}' })
  .input(
    z.object({
      id: z.string(),
      with: incomingFaxWithSchema.optional(),
    }),
  )
  .output(incomingFaxSchema)
